/*-----------------------------------------------------------
* Template Name    : Anj - Creative Portfolio Template
* Author           : beingeorge
* Version          : 1.0
* Created          : Mar 2020
* File Description : Main Js file of the template
*------------------------------------------------------------
*/

! function($) {
    "use strict";

    /* ---------------------------------------------- /*
    * Preloader
    /* ---------------------------------------------- */

    $(window).on('load', function() {
        $('#preloader').addClass("loaded");
    });

    /* ---------------------------------------------- /*
    * Section Scroll - Navbar
    /* ---------------------------------------------- */
    
    $('.navbar-nav a, .btn').on('click', function(event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top - 0
        }, 1500, 'easeInOutExpo');

        if($('.navbar').hasClass('active')){
            $('.navbar').removeClass('active')
            $('.ham').removeClass('active')
        }

        event.preventDefault();
    });

    $('.navbar-toggler').on('click', function(){
        $("body").toggleClass('aside-open');
        $(".ham").toggleClass('active');
        $("body, html").toggleClass('overflow-hidden');
    });

    /* ---------------------------------------------- /*
    * Scroll Spy - init
    /* ---------------------------------------------- */

    $("#navbarCollapse").scrollspy({
        offset:20
    });


    /* ---------------------------------------------- /*
    * AnimateOnScroll - Init
    /* ---------------------------------------------- */

    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null,    // optional scroll container selector, otherwise use window,
        resetAnimation: true,     // reset animation on end (default is true)
      }
    );
    wow.init();

    /* ---------------------------------------------- /*
    * Initialize shuffle plugin
    /* ---------------------------------------------- */

    var $portfolioContainer = $('.list-items-container');

    $('#filter li').on('click', function (e) {
        e.preventDefault();

        $('#filter li').removeClass('active');
        $(this).addClass('active');

        var group = $(this).attr('data-group');
        var groupName = $(this).attr('data-group');

        $portfolioContainer.shuffle('shuffle', groupName );
    });

    /* ---------------------------------------------- /*
    * Material Button Init
    /* ---------------------------------------------- */

    /* Arlina Design Material Button by http://www.arlinadzgn.com */
    (function($) {
        $(".ripple").on('click', function (e) {
            var rippler = $(this);
            if(rippler.find(".teffect").length === 0) {
                rippler.append("<span class='teffect'></span>");
            }
            var teffect = rippler.find(".teffect");
            teffect.removeClass("animate");
            if(!teffect.height() && !teffect.width())
            {
                var d = Math.max(rippler.outerWidth(), rippler.outerHeight());
                teffect.css({height: d, width: d});
            }
            var x = e.pageX - rippler.offset().left - teffect.width()/2;
            var y = e.pageY - rippler.offset().top - teffect.height()/2;
            teffect.css({
                top: y+'px',
                left:x+'px'
            }).addClass("animate");
            // e.preventDefault();
        })
    })(jQuery);

    /* ---------------------------------------------- /*
    * Parallax init
    /* ---------------------------------------------- */

    if ( $( "#scene" ).length ) {
        var scene = document.getElementById('scene');
        var parallaxInstance = new Parallax(scene);
    }
    /* ---------------------------------------------- /*
    * Typed init
    /* ---------------------------------------------- */

    $(".typed").each(function() {
        var $this = $(this);
        $this.typed({
            strings: $this.attr('data-elements').split(','),
            typeSpeed: 100,
            backDelay: 3000
        });
    });

    /* ---------------------------------------------- /*
    * Section background color
    /* ---------------------------------------------- */
    $(".section:even").addClass("section-light");
    $(".section:odd").addClass("section-dark");

}(window.jQuery);

